module.exports = __webpack_public_path__ + "static/media/notification.2120ad4d.svg";